/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Box, Typography, WithStyles } from '@material-ui/core';
import { generateStyle } from '../../utils/styles';
import Style from './style';
//import useStyles from './style';
//import Style from './style';
//import { RootState } from '../../reducers';


export interface Props extends WithStyles<typeof Style> {
	[name: string]: any;
}
/**
 *
 */

 const Page404: React.FC<Props> = ({classes,name }: Props) => {
//	const classes = useStyles();

	return (
		<Box className={classes.root}>
			
				<Typography >
					Privacy PolicyTBD
				</Typography>
			</Box>
	);
};

export default generateStyle(Style, 'Page404')(Page404);